import actionTypes from 'constants/actionTypes'
import single from './single'
import defaultsDeep from 'lodash/defaultsDeep'
import cloneDeep from 'lodash/cloneDeep'
import { isHardFail } from 'lib/action'

type KindEntity = unknown
type KindsState = Record<string, KindEntity>

interface KindsAction {
  type?: string
  payload?: {
    id?: string
    data?: {
      id?: string
    }
  }
  previousPayload?: {
    id?: string
  }
  error?: unknown
}

const upsertKindByAction = (state: KindsState, action: KindsAction): KindsState => {
  const id = action.payload?.id || action.payload?.data?.id || action.previousPayload?.id
  if (!id) return state
  return defaultsDeep(
    {
      [id]: single(state[id] as never, action as never, { id }),
    },
    state
  )
}

const all = (state: KindsState = {}, action: KindsAction): KindsState => {
  const actionType = action.type ?? ''
  switch (true) {
    case actionType === actionTypes.KINDS.ONE.CREATE.FAIL: {
      const id = action.previousPayload?.id
      if (!id) return state
      if (isHardFail(action)) {
        const updated = cloneDeep(state)
        delete updated[id]
        return updated
      }
      return upsertKindByAction(state, action)
    }

    case [
      actionTypes.KINDS.ONE.CREATE.REQUEST,
      actionTypes.KINDS.ONE.CREATE.RECEIVE,
      actionTypes.KINDS.ONE.CREATE.NOTIFY,
      actionTypes.KINDS.ONE.EDIT.REQUEST,
      actionTypes.KINDS.ONE.EDIT.RECEIVE,
      actionTypes.KINDS.ONE.EDIT.NOTIFY,
      actionTypes.KINDS.ONE.EDIT.FAIL,
      actionTypes.KINDS.ONE.DELETE.REQUEST,
      actionTypes.KINDS.ONE.DELETE.RECEIVE,
      actionTypes.KINDS.ONE.DELETE.NOTIFY,
      actionTypes.KINDS.ONE.DELETE.FAIL
    ].includes(actionType): {
      return upsertKindByAction(state, action)
    }

    default:
      return state
  }
}

export default all
